<template>
  <ion-content id="app" class="ion-padding page-content">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <InputTag showSearchWords="0"/>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12" size-sm="6" offset-sm="3">
          <ContentFields modus="new"/>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</template>

<script>
  import InputTag from ".././../components/tag/InputTag.vue";
  import {mapActions} from "vuex";
  import 'core-js/es6/array';
  import ContentFields from "../../components/content/ContentFields";

  export default {
    name: 'ContentNew',
    methods: {
      ...mapActions(["removeAllMessages"]),
    },
    components: {ContentFields, InputTag},
    created() {
      this.removeAllMessages();
    }
  }
</script>

<style scoped>

  ion-col {
    padding: 0;
    --padding: 0;
  }

</style>
